export default "__VITE_ASSET__CSYFg9Mu__"